import { Box, Chip, FormControl, InputBase, ListItemText, MenuItem, Select, styled } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/LocationOnRounded';
import react, { useState } from 'react'
import UserAvatar from '../../../../utils/Avatar/Avatar';

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        minWidth: 200,
        width: 200,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #dce5eb',
        fontSize: 16,
        color: '#617684',
        padding: '10px 26px 10px 12px',
        boxShadow: '0 2px 6px 0 rgba(0,0,0,.05),0 0 3px 0 rgba(0,0,0,.1)',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    }
}));

const MenuSelect = (props: any) => {
    const [val, setVal] = useState(0);
    const handleChange = (event: any) => {
        setVal(event.target.value);
        props.valueChange(event.target.value)
    };

    return (
        <FormControl sx={{ m: 1, minWidth: 200 }} disabled={props.disabled}>
            <Select
                className='inputBaseWidth'
                value={val}
                onChange={handleChange}
                input={<BootstrapInput placeholder='From' />}
                renderValue={(selected) => {
                    const selectedUser = props.items.filter((elm:any) => (elm.placement.Id === selected))[0]
                    if (selected === 0) {
                        return <em>{props.label}</em>;
                    }
                    else {
                        return (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                <Chip className='chip font-weight-700' key={selected} label={`${selectedUser.user.first_name} ${selectedUser.user.last_name}`} />
                            </Box>
                        )

                    }
                }}
            >
                <MenuItem disabled value={0}>
                    <em>{props.label}</em>
                </MenuItem>
                {
                    props.items.map((elm: any) => {
                        return (
                            <MenuItem key={elm.placement.Id} value={elm.placement.Id}>
                                <UserAvatar name={`${elm.user.first_name} ${elm.user.last_name}`} />
                                <ListItemText primary={`${elm.user.first_name} ${elm.user.last_name}`} />
                            </MenuItem>
                        )
                    })
                }
            </Select>
        </FormControl>

    )

}
export default MenuSelect